import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { LMLoggerService } from './lm-logger.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';

@Injectable()
export class LMAccessibleWebAppService {
  constructor(
    private http: HttpClient,
    private lmLoggerService: LMLoggerService,
    private lmUrlUtilService: LMUrlUtilService,
  ) {}

  public getAccessibleApps(): Observable<LMWebAppSpec[]> {
    const url = this.lmUrlUtilService.getAccessibleWebAppsUrl();
    const userTimeZone = this.lmUrlUtilService.getHeaderForUserTimeZone();

    return this.http.get(url, userTimeZone).pipe(
      map((response: any) => response as LMWebAppSpec[]),
      catchError(error => this.handleError(error))
    );
  }

  public getAccessDenied(): Observable<any> {
    const url = this.lmUrlUtilService.getAccessDeniedUrl();

    return this.http.get(url).pipe(
      catchError(error => this.handleError(error))
    );
  }

  private handleError(error: Response) {
    this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }
}
